import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Grid, Paper, Typography } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: theme.spacing(1),
    backgroundColor: 'inherit',
    border: '1px solid ' + theme.palette.background.paper,
    width: '100%',
    boxSizing: 'border-box',
    marginInline: 0,
  },
  title: {
    backgroundColor: 'inherit',
    color: theme.palette.background.paper,
    padding: '0 ' + theme.spacing(1) + 'px',
  },
  darkTheme: {
    color: theme.palette.common.white,
    border: '1px solid ' + theme.palette.common.white,
  },
  darkThemeTitle: {
    color: theme.palette.common.white,
  },
}));

export interface ITileGroup {
  title?: string;
  children?: any;
  hide?: boolean;
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  noGrid?: boolean;
  theme?: 'light' | 'dark';
}

export default function TileGroup({ title, children, hide = false, spacing = 2, noGrid = false, theme = 'light' }: ITileGroup) {
  const classes = useStyles();
  const muitheme = useTheme();

  return (
    <Paper
      style={{
        display: hide ? 'none' : '',
        padding: muitheme.spacing(spacing),
        margin: `auto ${muitheme.spacing(spacing)}px`,
        width: `calc(100% - ${2 * muitheme.spacing(spacing)}px)`,
        textAlign: 'left',
      }}
      className={clsx(classes.container, theme === 'dark' ? classes.darkTheme : '')}
      elevation={0}
      component='fieldset'
    >
      <legend>
        <Typography className={clsx(classes.title, theme === 'dark' ? classes.darkThemeTitle : '')}>{title}</Typography>
      </legend>
      {noGrid ? (
        { children }
      ) : (
        <Grid container spacing={spacing}>
          {children}
        </Grid>
      )}
    </Paper>
  );
}
